// Angular dependencies
import { Component, HostListener, Inject } from '@angular/core';
import { Router } from '@angular/router';

// Services
import { ToastService } from './api/services/tdd/toast.service';
import { AuthService } from './api/auth/auth.service';

import { environment } from 'src/environments/environment';

import { SharepointService } from './shared/services/sharepoint/sharepoint.service';
import { PowerAutomateService } from './shared/services/power-automate.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  loggedIn: boolean = false;
  loader: boolean = true;
  environmentPro: boolean = environment.production;

  constructor(
    private authService: AuthService,
    public toast: ToastService,
    private router: Router,
    private spService: SharepointService,
    private powerAutomateService: PowerAutomateService
  ) { }

  async ngOnInit() {
    // sp service
    this.spService.baseUrl = 'https://sites.ey.com/sites/EYAbogados-TaxSuite';
    this.powerAutomateService.baseUrl =
      'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/token';

    // APP_INITIALIZER completes this same promise before the router can
    // activate an internal route or its first API request.
    await this.authService.initializeAuthentication();

    // CODE
    if (this.environmentPro) {
      this.loggedIn = localStorage.getItem('loggedIn') === 'true';
      if (this.loggedIn && !localStorage.getItem('userLogged')) {
        await this.router.navigate(['/tax-suite'], {
          queryParams: {
            errorType: 'Unauthorized',
          },
        });
      }
    } else {
      const userLogged = {
        suiteRole: 'Superadmin',
        name: 'Juan',
        lastname: 'Perez García',
        avatarUrl: 'imguser_123444',
        email: 'juan.perez.garcia@dev.ey.com',
        role: {
          id: '3',
          name: 'Manager',
        },
        subServiceLine: {
          id: '1',
          name: 'GCR - Accounting, Compliance and Reporting',
          abbreviation: 'ACR',
        },
        id: 2,
      };
      this.loggedIn = false;
      localStorage.setItem('loggedIn', 'false');
      localStorage.setItem('userLogged', JSON.stringify(userLogged));
    }

    // MSAL and the backend profile are ready before this point.
    this.loader = false;
  }

}
